import { Button } from "@/components/Base/Button";
import { Icon } from "@/components/Common/Icon";
import { IconNames } from "@/types/v2";
import { useTerminologyReplacer } from "@/hooks/useTerminologyReplacer";

export type FieldSection =
  | "customer"
  | "vehicle"
  | "appointments"
  | "employeeAndJob"
  | "financial"
  | "miscellaneous";

export interface FieldSectionManagerProps {
  availableSections: FieldSection[];
  visibleSections: Set<FieldSection>;
  onAddSection: (section: FieldSection) => void;
}

const SECTION_LABELS: Record<FieldSection, string> = {
  customer: "Customer",
  vehicle: "Vehicle",
  appointments: "Appointments",
  employeeAndJob: "Employee and Job",
  financial: "Financial",
  miscellaneous: "Miscellaneous",
};

export const FieldSectionManager = ({
  availableSections,
  visibleSections,
  onAddSection,
}: FieldSectionManagerProps) => {
  const { terminolizeAuto } = useTerminologyReplacer();

  const sectionsToShow = availableSections.filter(
    (section) => !visibleSections.has(section)
  );

  if (sectionsToShow.length === 0) {
    return null;
  }

  return (
    <div className="space-y-2">
      <p className="text-sm text-muted-foreground">Add sections:</p>
      <div className="flex flex-wrap gap-2">
        {sectionsToShow.map((section) => (
          <Button
            key={section}
            type="button"
            variant="outline"
            size="sm"
            onClick={() => onAddSection(section)}
            className="text-xs"
          >
            <Icon name={IconNames.plus} className="mr-1 h-3 w-3" />
            {terminolizeAuto(SECTION_LABELS[section])}
          </Button>
        ))}
      </div>
    </div>
  );
};
